
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-10 md:pt-12 lg:pt-16 pb-6 md:pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-12 mb-10 md:mb-12 lg:mb-16">
          <div className="col-span-2 md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/db812a398b3a5f225f48907587ff778a/54bd81e90ee1470e3e6fa64ffca4e524.png" 
              alt="みなとサービス" 
              className="h-7 md:h-8 lg:h-10 w-auto mb-3 md:mb-4"
            />
            <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
              長崎県を拠点とした軽運送事業。<br />
              引越しから貨物配送まで、<br />
              地域密着のサービスを提供します。
            </p>
          </div>

          <div>
            <h3 className="text-xs md:text-sm font-bold text-gray-300 mb-3 md:mb-4 uppercase tracking-wider">
              サービス
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/moving" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors">
                  引越しサービス
                </Link>
              </li>
              <li>
                <Link to="/furniture" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors">
                  家具・家電運搬
                </Link>
              </li>
              <li>
                <Link to="/disposal" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors">
                  不用品整理
                </Link>
              </li>
              <li>
                <Link to="/cargo" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors">
                  貨物配送
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs md:text-sm font-bold text-gray-300 mb-3 md:mb-4 uppercase tracking-wider">
              事業情報
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/about" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors">
                  事業概要
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs md:text-sm font-bold text-gray-300 mb-3 md:mb-4 uppercase tracking-wider">
              お問い合わせ
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="tel:0120-743-643" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <i className="ri-phone-fill"></i>
                  0120-743-643
                </a>
              </li>
              <li>
                <a href="https://lin.ee/Rm6h2gK" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  LINE公式アカウント
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <i className="ri-mail-fill"></i>
                  メールフォーム
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 md:pt-8 lg:pt-12">
          <div className="text-center overflow-hidden">
            <p className="text-[#ede9e3] text-3xl sm:text-4xl md:text-5xl lg:text-7xl xl:text-8xl 2xl:text-9xl font-bold tracking-tight" style={{ fontFamily: 'Arial, sans-serif' }}>
              MINATO SERVICE
            </p>
          </div>
        </div>

        <div className="mt-4 md:mt-6 lg:mt-8 pt-4 md:pt-6 lg:pt-8 border-t border-gray-800 text-center">
          <p className="text-[10px] md:text-xs lg:text-sm text-gray-500">
            © 2024 みなとサービス. All rights reserved. | 
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#ebe960] transition-colors ml-1">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
